import { render } from "./ApplicantSurvey.vue?vue&type=template&id=f760ed6a&scoped=true"
import script from "./ApplicantSurvey.vue?vue&type=script&lang=ts"
export * from "./ApplicantSurvey.vue?vue&type=script&lang=ts"

import "./ApplicantSurvey.vue?vue&type=style&index=0&id=f760ed6a&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-f760ed6a"
/* custom blocks */
import block0 from "./ApplicantSurvey.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script